module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_492018.3ecec793.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_492018.pdf
// module id = 887
// module chunks = 0